<template>
  <div class="confirmation-page">
    <header class="page-header">
      <div class="header-content">
        <div class="success-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22,4 12,14.01 9,11.01"></polyline>
          </svg>
        </div>
        <div class="header-text">
          <h1>Cotação Solicitada com Sucesso!</h1>
          <p class="subtitle">Seu pedido foi enviado e está sendo processado</p>
          <div v-if="quoteId" class="quote-id">
            <span class="label">Número da Cotação:</span>
            <span class="value">#{{ quoteId }}</span>
          </div>
        </div>
      </div>
    </header>

    <main class="page-main">
      <div class="confirmation-content">
        <div class="success-message">
          <h2>Obrigado pela sua solicitação!</h2>
          <p>
            Recebemos todos os seus dados e informações do veículo.
            Nossa equipe está analisando sua solicitação e retornaremos
            em breve com as melhores opções de seguro para você.
          </p>
        </div>

        <Timeline :current-step="1" />

        <div class="next-steps">
          <h3>O que acontece agora?</h3>
          <div class="steps-grid">
            <div class="step-card">
              <div class="step-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                </svg>
              </div>
              <h4>Análise Técnica</h4>
              <p>Nossa equipe analisa os dados do veículo e perfil do condutor</p>
            </div>

            <div class="step-card">
              <div class="step-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14,2 14,8 20,8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                </svg>
              </div>
              <h4>Cotização Personalizada</h4>
              <p>Preparamos as melhores opções de cobertura para seu perfil</p>
            </div>

            <div class="step-card">
              <div class="step-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <h4>Envio por E-mail</h4>
              <p>Você receberá o link da cotação no seu e-mail cadastrado</p>
            </div>
          </div>
        </div>

        <div class="contact-info">
          <h3>Precisa de Ajuda?</h3>
          <p>Nossa equipe está disponível para esclarecer dúvidas sobre o processo</p>
          <div class="contact-methods">
            <a href="https://wa.me/5524993062444" target="_blank" class="contact-item contact-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>(24) 99306-2444</span>
            </a>
            <a href="mailto:financeiro@vrtech.app" class="contact-item contact-link">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <span>financeiro@vrtech.app</span>
            </a>
          </div>
        </div>

        <div class="action-buttons">
          <button @click="goToEtrade" class="btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15,3 21,3 21,9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
            Voltar ao E-Trade
          </button>

          <button @click="newQuote" class="btn-secondary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14,2 14,8 20,8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
            </svg>
            Nova Cotação
          </button>
        </div>
      </div>
    </main>

    <footer class="page-footer">
      <p>VR Tech</p>
    </footer>
  </div>
</template>

<script>
import Timeline from '../components/Timeline.vue'

export default {
  name: 'ConfirmationPage',
  components: {
    Timeline
  },
  data() {
    return {
      quoteId: null,
      serial: null
    }
  },
  mounted() {
    this.quoteId = this.$route.query.quoteId
    this.serial = this.$route.query.serial
  },
  methods: {
    goToEtrade() {
      // Redirecionar para o sistema E-Trade
      // Em um cenário real, você teria a URL do E-Trade
      const etradeUrl = `https://etrade.example.com/quote/${this.serial}`
      window.open(etradeUrl, '_blank')
    },

    newQuote() {
      // Redirecionar para nova cotação com o mesmo serial
      this.$router.push({
        name: 'QuoteRequest',
        query: { serial: this.serial }
      })
    }
  }
}
</script>

<style scoped>
.confirmation-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  display: flex;
  flex-direction: column;
}

.page-header {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  padding: 3rem 0;
  text-align: center;
  box-shadow: 0 4px 20px rgba(40, 167, 69, 0.3);
}

.header-content {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.success-icon {
  margin-bottom: 1.5rem;
  animation: bounceIn 0.8s ease-out;
}

.header-text h1 {
  margin: 0 0 1rem 0;
  font-size: 2.5rem;
  font-weight: 700;
  letter-spacing: -0.025em;
}

.subtitle {
  margin: 0 0 1.5rem 0;
  font-size: 1.25rem;
  opacity: 0.9;
  font-weight: 400;
}

.quote-id {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(255, 255, 255, 0.1);
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.quote-id .label {
  font-weight: 500;
  opacity: 0.9;
}

.quote-id .value {
  font-weight: 700;
  font-family: 'Monaco', 'Menlo', monospace;
  font-size: 1.125rem;
}

.page-main {
  flex: 1;
  padding: 3rem 0;
}

.confirmation-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2rem;
}

.success-message {
  text-align: center;
  margin-bottom: 3rem;
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.success-message h2 {
  margin: 0 0 1rem 0;
  color: #244179;
  font-size: 1.75rem;
  font-weight: 600;
}

.success-message p {
  margin: 0;
  color: #6c757d;
  font-size: 1.125rem;
  line-height: 1.6;
}

.next-steps {
  margin-bottom: 3rem;
}

.next-steps h3 {
  text-align: center;
  margin: 0 0 2rem 0;
  color: #244179;
  font-size: 1.5rem;
  font-weight: 600;
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.step-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.step-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.step-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #244179 0%, #365494 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1rem;
  color: white;
}

.step-card h4 {
  margin: 0 0 0.75rem 0;
  color: #244179;
  font-size: 1.125rem;
  font-weight: 600;
}

.step-card p {
  margin: 0;
  color: #6c757d;
  font-size: 0.875rem;
  line-height: 1.5;
}

.contact-info {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
  text-align: center;
}

.contact-info h3 {
  margin: 0 0 1rem 0;
  color: #244179;
  font-size: 1.5rem;
  font-weight: 600;
}

.contact-info p {
  margin: 0 0 1.5rem 0;
  color: #6c757d;
  font-size: 1rem;
}

.contact-methods {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #244179;
  font-weight: 500;
}

.contact-link {
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid transparent;
}

.contact-link:hover {
  color: #20c997;
  border-color: #20c997;
  background-color: rgba(32, 201, 151, 0.1);
}

.action-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary,
.btn-secondary {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.875rem 2rem;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 180px;
  justify-content: center;
}

.btn-primary {
  background: #244179;
  color: white;
}

.btn-primary:hover {
  background: #365494;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(36, 65, 121, 0.3);
}

.btn-secondary {
  background: #F7D810;
  color: #244179;
  border: 2px solid #F7D810;
}

.btn-secondary:hover {
  background: #e6c20e;
  border-color: #e6c20e;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(247, 216, 16, 0.3);
}

.page-footer {
  background: #244179;
  color: white;
  text-align: center;
  padding: 1.5rem 0;
  margin-top: auto;
}

.page-footer p {
  margin: 0;
  font-weight: 600;
  font-size: 1rem;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  70% {
    transform: scale(0.9);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@media (max-width: 768px) {
  .header-content {
    padding: 0 1rem;
  }

  .header-text h1 {
    font-size: 2rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .confirmation-content {
    padding: 0 1rem;
  }

  .steps-grid {
    grid-template-columns: 1fr;
  }

  .contact-methods {
    flex-direction: column;
    gap: 1rem;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .header-text h1 {
    font-size: 1.75rem;
  }

  .subtitle {
    font-size: 0.875rem;
  }

  .quote-id {
    flex-direction: column;
    gap: 0.5rem;
  }

  .success-message h2 {
    font-size: 1.5rem;
  }

  .success-message p {
    font-size: 1rem;
  }
}
</style>
